import { WHITESPACE_TOP_ATTRIBUTE } from '../../../constants/attributes';
import isUserModifiedAttributeByElement from '../../../verifiers/is-user-modified-attribute-by-element';

const canEditTopWhitespace = (targetBlock) =>
  targetBlock &&
  targetBlock.hasAttribute(WHITESPACE_TOP_ATTRIBUTE) &&
  !isUserModifiedAttributeByElement(targetBlock, WHITESPACE_TOP_ATTRIBUTE);

export default canEditTopWhitespace;
